/**
 * KeyboardEvent.keyCode is deprecated.
 * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
 *
 * Switch to checking by key, for example:
 * event.key === 'Enter'
 */
const keyCodes = {
  enter: "Enter",
  escape: "Escape",
  backspace: "Backspace",
  up: "ArrowUp",
  down: "ArrowDown",
  left: "ArrowLeft",
  right: "ArrowRight",
  tab: "Tab",
  space: " ",
};

export { keyCodes };
